module.exports = __webpack_public_path__ + "img/icon_integralMall.97376191.png";